function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime/helpers/interopRequireDefault.js
// module id = 0
// module chunks = 0 1 2